import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

export const contentFields = {
  description: {
    type: "textarea",
    label: "Description",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 300,
    minWidth: 200,
    maxWidth: 500,
    placeholder: "Full description of the offering",
    icon: "FileText",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "content",
  },
  executive_summary: {
    type: "textarea",
    label: "Executive Summary",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 300,
    minWidth: 200,
    maxWidth: 500,
    placeholder: "Client-facing summary",
    icon: "Briefcase",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "content",
  },
  cta_href: {
    type: "text",
    label: "CTA URL",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 280,
    minWidth: 200,
    maxWidth: 400,
    placeholder: "https://chatbot.westtn.consulting",
    icon: "ExternalLink",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "content",
  },
  cta_text: {
    type: "text",
    label: "CTA Text",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    width: 120,
    minWidth: 80,
    maxWidth: 150,
    placeholder: "Sign Up, Get Quote",
    icon: "MousePointer",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "content",
  },
} satisfies Record<string, SimpleFieldConfig>;
